// getters
const RoutesDriversSchool = state => state.RoutesDriversSchool

export default {
  RoutesDriversSchool
}



// WEBPACK FOOTER //
// ./src/store/modules/schoolroutes/drivers/getters.js